import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Row } from "react-bootstrap";
import { Dropdown, Radio, Button } from "semantic-ui-react";
import {
  DateRangePicker,
  SingleDatePicker,
  DayPickerRangeController
} from "react-dates";
import moment from "moment";
import "moment/locale/el";
import "moment/locale/it";
import { translate, getLanguage } from "../Translation/Translation";

import { FETCH_URL } from "../../utilities";

import "react-dates/lib/css/_datepicker.css";
import "./TopNav.css";

require("../../../node_modules/babel-polyfill");

localStorage.removeItem(
  "currentSearch",
  "outgoingLocationCode",
  "arrivalLocation",
  "departureLocation"
); 

const styles = {
  navigation_row: {
    display: "inline-block",
    width: "100%",
    marginBottom: "30px",
    height: "45px"
  },
  navigation_row_no_margin: {
    display: "inline-block",
    width: "100%",
    height: "45px"
  },
  navigation_row_small_margin: {
    display: "inline-block",
    marginBottom: "20px",
    width: "100%",
    height: "45px"
  },
  navigation_container_fullpage: {
    display: "block",
    width: "100%",
    maxWidth: "1360px",
    left: "0px",
    right: "0px",
    margin: "auto",
    padding: "30px 0 0 0"
  },
  navigation_container: {
    display: "inline-block",
    width: "100%",
    maxWidth: "1360px",
    left: "0px",
    right: "0px",
    margin: "auto",
    display: "flex"
  },
  navigation_logo: {
    maxWidth: "150px",
    width: "150px",
    display: "inline-block",
    position: "absolute"
  },
  navigation_search: {
    maxWidth: "400px",
    width: "100%",
    left: "0px",
    right: "0px",
    margin: "auto",
    display: "flow-root",
    marginTop: "80px"
  },
  navigation_item: {
    width: "calc(50% - 20px)",
    transition: "all ease-in-out 0.5s",
    padding: "0px"
  },
  navigation_dropdown: {
    height: "45px",
    borderRadius: "0",
    position: "absolute",
    width: "320px"
  },
  languageSelector: {
    display: "flex"
  },
  languageDropdown: {
    width: "100%",
    height: "30px",
    marginLeft: "5px"
  },
  clearButton: { textAlign: "right !important", position: "relative", width: "100%" }
};

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = { revert: false };
    this.handleRevertClick = this.handleRevertClick.bind(this);
  }

  handleRevertClick(event, arrivalPort) {
    event.preventDefault();

    const { revert } = this.state;
    const { arrivalPortCode, departurePortCode } =
      this.props.data && this.props.data.data.settings;
    const { setArrivalPort, setDeparturePort } = this.props.data.data;

    if (arrivalPortCode && departurePortCode) {
      setArrivalPort(departurePortCode);
      setDeparturePort(arrivalPortCode);
      this.getArrivalPorts(arrivalPortCode);
    }
    this.setState({ revert: !this.state.revert });
  }

  triggerSearch = () => {

    const { setSelectedIncomingTrip, setSelectedOutgoingTrip, setDeparturePort, setArrivalPort } = this.props.data.data;
    
    if (this.props.data.data.settings.isRoundTrip) {
      if (this.state.startDate && this.state.endDate) {
        this.props.callbackSearch(
          this.props.data.data.settings.isRoundTrip,
          this.state.startDate.format("YYYY-MM-DD"),
          this.state.endDate.format("YYYY-MM-DD")
        );
      }
    } else {
      if (this.state.startDate) {
        this.props.callbackSearch(
          this.props.data.data.settings.isRoundTrip,
          this.state.startDate.format("YYYY-MM-DD"),
          null
        );
      }
    }
  };

  triggerClear = () => {
    this.props.data.data.setDeparturePort("");
    this.props.data.data.setArrivalPort("");
    this.props.data.data.setDates(
      (this.state.startDate = null),
      (this.state.endDate = null)
    );
  };

  rangeClicked = () => {
    this.props.data.data.setIsRoundTrip(
      !this.props.data.data.settings.isRoundTrip
    );
  };

  departureChanged(data) {
    this.setState({ revert: false });
    this.props.data.data.setDeparturePort(data.value === "ALL" ? "ALL" : data.value, "");
    this.getArrivalPorts(data.value);
  }

  arrivalChanged(data) {
    this.setState({ revert: false });
    this.props.data.data.setArrivalPort(data.value === "ALL" ? "ALL" : data.value, "");
  }

  calendarChanged = reactDates => {
    this.props.data.data.setDates(reactDates.startDate, reactDates.endDate);
  };

  getArrivalPorts(departurePortCode) {
    if (departurePortCode === "ALL") {
      this.props.data.data.setArrivalList(this.props.data.data.settings.departurePortList);
    } else {
      axios.all([this.fetchArrivalPorts('en', departurePortCode), this.fetchArrivalPorts('el', departurePortCode)])
        .then(axios.spread((en, gr) => {
          const portsInEnglish = en.data.map((p) => {
            const { name } = p;
            let port = p;
            if (name.indexOf(")") !== -1) {
              port.name = name.replace(")", ") ");
            }
            if (name.indexOf("(") !== -1 && name.indexOf("(") !== 1) {
              port.name = name.replace("(", " (");
            }
            return port;
          })
          const portsInGreek = gr.data.map((p) => {
            const { name } = p;
            let port = p;
            if (name.indexOf(")") !== -1) {
              port.name = name.replace(")", ") ");
            }
            if (name.indexOf("(") !== -1 && name.indexOf("(") !== 1) {
              port.name = name.replace("(", " (");
            }
            return port;
          })
          let portsToSearch = [];
          if (getLanguage() === "el") {
            portsToSearch = portsInGreek.reduce((ports, port) => {
              const foundPort = portsInEnglish.find((element) => {
                return element.id === port.id
              })
              if (foundPort && foundPort.name) {
                return ports.concat({ ...port, altName: foundPort.name });
              }
              return ports;
            }, []);
          } else {
            portsToSearch = portsInEnglish.reduce((ports, port) => {
              const foundPort = portsInGreek.find((element) => {
                return element.id === port.id
              })
              if (foundPort && foundPort.name) {
                return ports.concat({ ...port, altName: foundPort.name });
              }
              return ports;
            }, []);
          }
          this.props.data.data.setArrivalList(portsToSearch)
        }))

    }
  }

  customSearch = (data, value) => {
    return data.filter((element) => {
      return ((element.text.toUpperCase().indexOf(value.toUpperCase()) !== -1) || (element.alt.toUpperCase().indexOf(value.toUpperCase()) !== -1))
    });
  }

  fetchDeparturePorts = language => {
    return axios.get(`${FETCH_URL}/proxy.php?ws=90a0a8fc34c08bc03950dbb0cdaea32e/${language}`)
  }

  fetchArrivalPorts = (language, departurePortCode) => {
    return axios.get(`${FETCH_URL}/proxy.php?ws=963b26afd0814eac5aa146f4a664ee48/${language}/${departurePortCode}`)
  }

  componentDidMount() {
    axios.all([this.fetchDeparturePorts('en'), this.fetchDeparturePorts('el')])
      .then(axios.spread((en, gr) => {
        const portsInEnglish = en.data.map((p) => {
          const { name } = p;
          let port = p;
          if (name.indexOf(")") !== -1) {
            port.name = name.replace(")", ") ");
          }
          if (name.indexOf("(") !== -1 && name.indexOf("(") !== 1) {
            port.name = name.replace("(", " (");
          }
          return port;
        })
        const portsInGreek = gr.data.map((p) => {
          const { name } = p;
          let port = p;
          if (name.indexOf(")") !== -1) {
            port.name = name.replace(")", ") ");
          }
          if (name.indexOf("(") !== -1 && name.indexOf("(") !== 1) {
            port.name = name.replace("(", " (");
          }
          return port;
        })
        let portsToSearch = [];
        if (getLanguage() === "el") {
          portsToSearch = portsInGreek.reduce((ports, port) => {
            const foundPort = portsInEnglish.find((element) => {
              return element.id === port.id
            })
            if (ports && foundPort) {
              return ports.concat({ ...port, altName: foundPort.name });
            }
            return ports;
          }, []);
        } else {
          portsToSearch = portsInEnglish.reduce((ports, port) => {
            const foundPort = portsInGreek.find((element) => {
              return element.id === port.id
            })
            if (ports && foundPort) {
              return ports.concat({ ...port, altName: foundPort.name });
            }
            return ports;
          }, []);
        }
        this.props.data.data.setDepartureList(portsToSearch)
      }))

    let searchParams = JSON.parse(localStorage.getItem("currentSearch"));
    if (this.props.data && this.props.data.match.params.sdate) {
      this.props.data.data.setDeparturePort(
        this.props.data.match.params.from,
        "Label"
      );
      this.props.data.data.setArrivalPort(
        this.props.data.match.params.to,
        "Label"
      );
      this.props.data.data.setDates(
        this.props.data.match.params.sdate,
        this.props.data.match.params.edate
      );
      this.setState({
        startDate: moment(this.props.data.match.params.sdate, "YYYY-MM-DD"),
        endDate: moment(this.props.data.match.params.edate, "YYYY-MM-DD")
      });

      this.props.data.data.setSearchParameters(
        this.props.data.match.params.sdate,
        this.props.data.match.params.edate,
        this.props.data.match.params.from,
        this.props.data.match.params.to
      );
    } else if (searchParams) {
      this.props.data.data.setDeparturePort(
        searchParams.outgoingLocationCode,
        "Label"
      );
      this.props.data.data.setArrivalPort(
        searchParams.incomingLocationCode,
        "Label"
      );
      this.props.data.data.setDates(
        searchParams.outgoingDate,
        searchParams.incomingDate
      );
      this.setState({
        startDate: moment(searchParams.outgoingDate, "YYYY-MM-DD"),
        endDate: moment(searchParams.incomingDate, "YYYY-MM-DD")
      });

      this.props.data.data.setSearchParameters(
        searchParams.outgoingLocationCode,
        searchParams.incomingLocationCode,
        searchParams.outgoingDate,
        searchParams.incomingDate
      );
    }
    if (this.props.data.match.params.from) {
      this.getArrivalPorts(this.props.data.match.params.from);
    } else if (searchParams && searchParams.outgoingLocationCode) {
      this.getArrivalPorts(searchParams.outgoingLocationCode);
    }
  }

  changeLanguage = language => {
    localStorage.setItem("language", language);
    window.location.reload();
  };

  render() {
    moment.locale(getLanguage());
    const width = window.innerWidth;
    let orientation = "horizontal";
    if (width < 768) {
      orientation = "vertical";
    }

    let arrivals = [];
    let departures = [];

    if (this.props.data && this.props.data.data.settings.departurePortList) {
      departures = [
        { key: "ALL", value: "ALL", text: translate(getLanguage(), "All"), alt: "ALL" },
        ...this.props.data.data.settings.departurePortList.map(port => {
          return { key: port.code, value: port.code, text: port.name, alt: port.altName };
        })
      ];
    }

    if (this.props.data && this.props.data.data.settings.arrivalPortList) {
      arrivals = [
        { key: "ALL", value: "ALL", text: translate(getLanguage(), "All"), alt: 'ALL' },
        ...this.props.data.data.settings.arrivalPortList.map(port => {
          return { key: port.code, value: port.code, text: port.name, alt: port.altName };
        })
      ];
    }

    const { currentValue } = this.state;
    const today = moment();
    const oneYearAgo = today.subtract(1, "year").subtract(1, "day");
    const { revert } = this.state;

    return (
      <div>
        {
          <div>
            <div style={styles.navigation_container_fullpage}>
              <Link to="/">
                <img
                  className="logoImage"
                  src="/images/base_logo.png"
                  style={styles.navigation_logo}
                />
              </Link>

              <div className="languageSwitcher" style={styles.languageSelector}>
                <div
                  className="languageItem english"
                  style={
                    getLanguage() == "en" ? { opacity: 1 } : { opacity: 0.4 }
                  }
                  onClick={() => this.changeLanguage("en")}
                >
                  {" "}
                </div>
                <div
                  className="languageItem greek"
                  style={
                    getLanguage() == "el" ? { opacity: 1 } : { opacity: 0.4 }
                  }
                  onClick={() => this.changeLanguage("el")}
                >
                  {" "}
                </div>
                <div
                  className="languageItem italian"
                  style={
                    getLanguage() == "it" ? { opacity: 1 } : { opacity: 0.4 }
                  }
                  onClick={() => this.changeLanguage("it")}
                >
                  {" "}
                </div>
              </div>
              <div className="searchContainer" style={styles.navigation_search}>
                <Row
                  className="searchRow"
                  style={styles.navigation_row_no_margin}
                >
                  <div className="searchRow-container">
                    <button
                      className="revertButton"
                      onClick={this.handleRevertClick}
                    >
                      <span
                        className="glyphicon glyphicon-sort revert-icon"
                        aria-hidden="true"
                      />
                    </button>
                    <div
                      className="searchItem"
                      style={{
                        background: "rgb(140,216,248)",
                        width: "40px",
                        height: "45px",
                        display: "inline-block",
                        position: "absolute"
                      }}
                    >
                      <div className="navFlag" />
                    </div>

                    <Dropdown
                      onChange={(event, data) => this.departureChanged(data)}
                      onBlur={this.dropdownBlured}
                      className="navigationDropdownItem navigationDropdownLeft"
                      style={{
                        height: "45px",
                        borderRadius: "0",
                        position: "absolute",
                        textAlign: "center"
                      }}
                      placeholder={translate(getLanguage(), "Departure")}
                      search={this.customSearch}
                      selection
                      value={
                        (this.props.data &&
                          this.props.data.data.settings.departurePortCode)
                      }
                      options={departures ? departures : []}
                      selectOnBlur={false}
                    />

                    <Dropdown
                      onChange={(e, data) => this.arrivalChanged(data)}
                      onBlur={this.dropdownBlured}
                      style={{
                        height: "45px",
                        borderRadius: "0",
                        position: "absolute",
                        textAlign: "center"
                      }}
                      className="navigationDropdownItem navigationDropdownRight"
                      placeholder={translate(getLanguage(), "Arrival")}
                      search={this.customSearch}
                      selection
                      value={
                        this.props.data &&
                        this.props.data.data.settings.arrivalPortCode
                      }
                      options={arrivals ? arrivals : []}
                      selectOnBlur={false}
                    />
                  </div>
                </Row>
                <Row className="searchRow roundTripRow">
                  <Radio
                    toggle
                    style={{ float: "right" }}
                    checked={this.props.data.data.settings.isRoundTrip}
                    onChange={() => this.rangeClicked()}
                  />
                  <span
                    style={{
                      position: "relative",
                      float: "right",
                      color: "white",
                      marginTop: "10px",
                      marginRight: "10px"
                    }}
                  >
                    {translate(getLanguage(), "Round Trip")}
                  </span>
                </Row>
                <Row
                  className="searchRow"
                  style={styles.navigation_row_small_margin}
                >
                  <div
                    className="searchItem"
                    style={{
                      background: "rgb(140,216,248)",
                      width: "40px",
                      height: "45px",
                      display: "inline-block",
                      position: "absolute"
                    }}
                  >
                    <div className="navCalendar" />
                  </div>

                  {this.props.data &&
                    this.props.data.data.settings.isRoundTrip ? (
                      <div className="rangeDay">
                        <DateRangePicker
                          minimumNights={0}
                          startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                          endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                          onDatesChange={({ startDate, endDate }) =>
                            this.setState({ startDate, endDate })
                          }
                          focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                          onFocusChange={focusedInput =>
                            this.setState({ focusedInput })
                          } // PropTypes.func.isRequired,
                          orientation={orientation}
                          showClearDates
                          startDatePlaceholderText={translate(
                            getLanguage(),
                            "Departure Date"
                          )}
                          endDatePlaceholderText={translate(
                            getLanguage(),
                            "Return Date"
                          )}
                          phrases={{
                            closeDatePicker: "Close",
                            clearDates: "Clear"
                          }}
                          displayFormat="DD/MM/YYYY"
                          isOutsideRange={date => oneYearAgo.isAfter(date)}
                        />
                      </div>
                    ) : (
                      <div className="singleDay">
                        <SingleDatePicker
                          date={this.state.startDate} // momentPropTypes.momentObj or null,
                          onDateChange={startDate => this.setState({ startDate })} // PropTypes.func.isRequired
                          focused={this.state.focused} // PropTypes.bool
                          readOnly
                          onFocusChange={({ focused }) =>
                            this.setState({ focused })
                          } // PropTypes.func.isRequired
                          orientation={orientation}
                          placeholder={translate(getLanguage(), "Departure Date")}
                          phrases={{
                            closeDatePicker: "Close",
                            clearDates: "Clear"
                          }}
                          displayFormat="DD/MM/YYYY"
                          isOutsideRange={date => oneYearAgo.isAfter(date)}
                          enableOutsideDays
                        />
                      </div>
                    )}
                </Row>
                <Row className="searchRow" style={styles.navigation_row}>
                  <Button
                    style={ styles.clearButton }
                    className="clearButton"
                    primary
                    loading={this.props.isloading}
                    onClick={() => this.triggerClear()}
                  >
                    {translate(getLanguage(), "Clear Search")}
                  </Button>

                  <Button
                    style={{ width: "100%", position: "relative" }}
                    className="searchButton homeButton"
                    primary
                    loading={this.props.isloading}
                    onClick={() => this.triggerSearch()}
                  >
                    {translate(getLanguage(), "Search")}
                  </Button>
                </Row>
              </div>
            </div>
            <div style={styles.filterBlack} />
          </div>
        }
      </div>
    );
  }
}

export default TopNav;



// WEBPACK FOOTER //
// ./src/components/Header/TopNav.js